// Map Search Scripts
(function() {
    // All state polygons
    let boundaries = [];
    // All markers
    let markerArray = [];
    // Center map on US by default
    let mapCenter = { lat:38.522458, lng:-83.704500 };
    // Default zoom level for map
    let defaultZoom = 5;
    // Button to reset search
    let resetButton = document.getElementById('btn-reset-map');
    let currentInfowindow;
    // Shared polygon options
    const polygonOptions = {
        strokeWeight: 1,
        strokeColor:'#ffffff',
        fillColor: '#E02726',
        fillOpacity: .75,
    };
    const hoverOptions = {
        strokeWeight: 1,
        strokeColor:'#ffffff',
        fillColor: '#E02726',
        fillOpacity: 1,
    };
    const activeOptions = {
        strokeWeight: 1,
        strokeColor:'#ffffff',
        fillColor: '#E02726',
        fillOpacity: 0.25,
    };
    // Polygon events
    function setActiveOptions(event) {
        const polygon = this;
        polygon.setOptions(activeOptions);
    }
    function setHoverOptions(event) {
        const polygon = this;
        polygon.setOptions(hoverOptions);
    }
    function resetOptions(event) {
        const polygon = this;
        polygon.setOptions(polygonOptions);
    }
    function initStateInfowindow(event, searchMap, polygon, boundary, is_polygon) {
        if (currentInfowindow) {
            currentInfowindow.close();
        }
        let point;
        let infowindow = new google.maps.InfoWindow({
            content: `
                <div class="map-search-infowindow state-infowindow">
                  <h3 class="mb-0 h5">${polygon.full_name}</h3>
                </div>
            `,
            ariaLabel: polygon.full_name,
        });
        let coords = [];
        if (is_polygon == true) {
            for (let i = 0; i < boundary.length; i++) {
                let coord = boundary[i];
                coords.push(coord);
            }
        } else {
            for (let i = 0; i < boundary.length; i++) {
                let innerArray = boundary[i];
                for (let ii = 0; ii < innerArray.length; ii++) {
                    let coord = innerArray[ii];
                    coords.push(coord);
                }
            }
        }
        let clearPosition = getClearPosition(coords);
        infowindow.setPosition(clearPosition);
        infowindow.open(searchMap.map);
        polygon.addListener('click', (e) => {
            infowindow.close();
        });
        currentInfowindow = infowindow;
    }
    // Get a clear position for an infowindow above a polygon
    function getClearPosition(coords) {
        let lat = -5000;
        let lng = 0;
        for (let i = 0; i < coords.length; i++) {
            if (coords[i].lat > lat) {
                lat = coords[i].lat;
                lng = coords[i].lng;
            }
        }
        return { lat, lng };
    }
    function getPolygonBounds(polygon) {
        var bounds = new google.maps.LatLngBounds();
        var paths = polygon.getPaths();
        var path;
        for (var i = 0; i < paths.getLength(); i++) {
            path = paths.getAt(i);
            for (var ii = 0; ii < path.getLength(); ii++) {
                bounds.extend(path.getAt(ii));
            }
        }
        return bounds;
    }
    function clickPolygon(event, stateBorder, searchMap, marketMapJSON, pinSVG) {
        const polygon = stateBorder;
        polygon.setOptions(activeOptions);
        google.maps.event.clearListeners(stateBorder, 'mouseover');
        polygon.addListener('mouseover', setActiveOptions);
        polygon.addListener('mouseout', setActiveOptions);
        let statesToDraw = [polygon.name];
        updateStatePolygons(event, searchMap, statesToDraw);
        addMarkers(event, polygon.name, searchMap, marketMapJSON, pinSVG);
        updateResetButton(resetButton, true, stateBorder.full_name);
        let map = document.getElementById('oimapsearch');
        let pointerEventsInitial = map.style.pointerEvents;
        map.style.pointerEvents = 'none';
        setTimeout(() => {
            map.style.pointerEvents = pointerEventsInitial;
        }, 1000);
    }
    function addMarkers(event, state, searchMap, marketMapJSON, pinSVG) {
        markerArray = [];
        for (let marketObj of marketMapJSON) {
            if (marketObj.state == state) {
                // Get lat/lng position
                let postition = {
                    lat: parseFloat(marketObj.latitude),
                    lng: parseFloat(marketObj.longitude),
                };
                let marker = new google.maps.Marker({
                    position: postition,
                    map: searchMap.map,
                    icon: {
                        url: pinSVG,
                        size: new google.maps.Size(256, 48),
                    },
                    title: marketObj.market_name,
                    link: marketObj.permalink,
                    locations: marketObj.locations,
                    specs: marketObj.specs,
                    label: {
                        text: marketObj.market_name,
                        className: 'market-marker-label'
                    },
                });
                const infowindow = new google.maps.InfoWindow({
                    content: `
                        <div class="map-search-infowindow">
                            <h3 class="h6"><a class="link-primary mb-1" href="${marker.link}">${marker.title}</a></h3>
                            <ul>
                                <li><a href="${marker.link}">${marker.locations} Communities</a></li>
                                <li><a href="${marker.link}available/">${marker.specs} Available Homes</a></li>
                            </ul>
                        </div>
                    `,
                    ariaLabel: marketObj.market_name,
                });
                marker.addListener('mouseover', () => {
                    if (currentInfowindow) {
                        currentInfowindow.close();
                    }
                    infowindow.open({
                        anchor: marker,
                        map: searchMap.map,
                    });
                    currentInfowindow = infowindow;
                });

                marker.addListener('click', () => {
                    window.location.href = marker.link;
                    infowindow.close();
                });
                if (!markerArray.includes(marker)) {
                    markerArray.push(marker);
                }
            }
        }
    }
    function updateStatePolygons(event, searchMap, statesToDraw) {
        for (let boundary of boundaries) {
            if (statesToDraw.includes(boundary.state)) {
                boundary.border.setMap(searchMap.map);
                if (statesToDraw.length == 1) {
                    searchMap.map.fitBounds(getPolygonBounds(boundary.border));
                }
            } else {
                boundary.border.setMap(null);
            }
        }
    }
    function updateResetButton(button, active=false, text) {
        if (active) {
            button.classList.add('active');
        }
        else {
            button.classList.remove('active');
        }
        if (text) {
            button.innerHTML = `<i class="fa-light fa-undo" aria-hidden="true"></i> ${text}`;
        }
    }

    window.initStatePolygons = function(event, searchMap, stateJSON, marketMapJSON, pinSVG) {
        let index = 0;
        // Add polygon for each state
        for (let stateObj of stateJSON) {
            if (stateObj.google_boundary && Array.isArray(stateObj.google_boundary)) {
                let stateBorder = new google.maps.Polygon({
                    paths: stateObj.google_boundary,
                    name: stateObj.state,
                    options: polygonOptions,
                    full_name: stateObj.state_name,
                });
                boundaries.push({
                    state: stateObj.state,
                    index: index,
                    border: stateBorder,
                });
                stateBorder.setMap(searchMap.map);
                // Add initial event listeners for this polygon
                stateBorder.addListener('mouseover', setHoverOptions);
                stateBorder.addListener('mouseover', (event) => {
                    initStateInfowindow(event, searchMap, stateBorder, stateObj.google_boundary, stateObj.is_polygon);
                });
                stateBorder.addListener('mouseout', resetOptions);
                stateBorder.addListener('click', (e) => {
                    clickPolygon(e, stateBorder, searchMap, marketMapJSON, pinSVG);
                });
                index += 1;
            }
        }
        searchMap.map.setCenter(mapCenter);
        searchMap.map.setZoom(defaultZoom);
    };
    window.resetMap = function(event, searchMap, stateJSON, marketMapJSON, pinSVG) {
        if (currentInfowindow) {
            currentInfowindow.close();
        }
        updateResetButton(resetButton);
        updateStatePolygons(event, searchMap, []);
        boundaries = [];
        for (let i = 0; i < markerArray.length; i++) {
            markerArray[i].setMap(null);
        }
        markerArray = [];
        if(stateJSON){
            initStatePolygons(event, searchMap, stateJSON, marketMapJSON, pinSVG);
        }
    };

    window.anchorHomeMap = function() {
        let myModalEl = document.getElementById('search-modal');
        let myNav = document.getElementById('main-nav');
        let scrollToDiv = document.getElementById('map-search');

        let searchModal = bootstrap.Modal.getInstance(myModalEl)
        let mobileNav = bootstrap.Offcanvas.getInstance(myNav)

        if(searchModal != null){
            searchModal.hide();
        }

        if(mobileNav != null){
            mobileNav.hide();
        }

       if(scrollToDiv != null){
            scrollToDiv.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
})();
